import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=0408cb5b&scoped=true&"
import script from "./CheckboxInput.vue?vue&type=script&lang=js&"
export * from "./CheckboxInput.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=0408cb5b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0408cb5b",
  null
  
)

export default component.exports